var map = {
	"./black.png": 9473,
	"./cursor.png": 8476,
	"./entities/chest.png": 2080,
	"./entities/door.png": 8754,
	"./entities/items.png": 6257,
	"./entities/lockeddoor.png": 2350,
	"./entities/npc.png": 9795,
	"./entities/sign.png": 9351,
	"./entities/warp.png": 5675,
	"./grid-all.png": 3534,
	"./grid-down.png": 1456,
	"./grid-right.png": 1844,
	"./grid.png": 8338,
	"./specs/0.png": 8195,
	"./specs/1.png": 4411,
	"./specs/10.png": 7131,
	"./specs/11.png": 8272,
	"./specs/12.png": 6716,
	"./specs/13.png": 4766,
	"./specs/14.png": 2405,
	"./specs/15.png": 9844,
	"./specs/16.png": 5400,
	"./specs/17.png": 9250,
	"./specs/18.png": 897,
	"./specs/19.png": 2354,
	"./specs/2.png": 2289,
	"./specs/20.png": 955,
	"./specs/21.png": 7794,
	"./specs/22.png": 4229,
	"./specs/23.png": 6546,
	"./specs/24.png": 1805,
	"./specs/25.png": 5433,
	"./specs/26.png": 518,
	"./specs/27.png": 1922,
	"./specs/28.png": 699,
	"./specs/29.png": 3656,
	"./specs/3.png": 5962,
	"./specs/30.png": 8602,
	"./specs/31.png": 5502,
	"./specs/32.png": 6256,
	"./specs/33.png": 4837,
	"./specs/34.png": 5907,
	"./specs/35.png": 5954,
	"./specs/36.png": 7284,
	"./specs/4.png": 4257,
	"./specs/5.png": 6540,
	"./specs/6.png": 1309,
	"./specs/7.png": 108,
	"./specs/8.png": 5595,
	"./specs/9.png": 9438
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1230;